import { isString } from 'lodash';

const isFullString = value => isString(value) && value !== '';

// noinspection JSUnusedGlobalSymbols
export default isFullString;
